export default __webpack_public_path__ + "static/portfolio_gallery_13-ce82cecb956f712e562d3bf763582092.jpg";